import { UserRolesEnum } from './shared/models/user.model';
// angular
import { NgModule } from '@angular/core';
import { Routes, PreloadingStrategy, RouterModule, Route } from '@angular/router';

// modules
import { CoreModule } from '@core/core.module';
import { AppStoreModule } from '@store/store.module';

// addons
import { Observable, timer, of } from 'rxjs';
import { flatMap } from 'rxjs/operators';

// components
import { AppComponent } from './app.component';

// guards
import { NoAuthGuard, AuthGuard, InitiateGuard } from '@core/guards';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import ('./views/login/login.module').then(m => m.LoginModule),
    data: {
      state: 'login',
      preload: true,
      delay: true
    },
    canActivate: [NoAuthGuard]
  },
  {
    path: 'forgot',
    loadChildren: () => import ('./views/forgot/forgot.module').then(m => m.ForgotModule),
    canActivate: [NoAuthGuard]
  },
  {
    path: 'recovery',
    loadChildren: () => import ('./views/recovery/recovery.module').then(m => m.RecoveryModule),
    canActivate: [NoAuthGuard]
  },
  {
    path: 'initiate',
    loadChildren: () => import ('./views/initiate/initiate.module').then(m => m.InitiateModule),
    data: {
      state: 'initiate',
      preload: true,
      delay: true,
    },
    canActivate: [AuthGuard, InitiateGuard]
  },
  {
    path: 'setpassword',
    loadChildren: () => import ('./views/setpassword/setpassword.module').then(m => m.SetPasswordModule),
    canActivate: [NoAuthGuard]
  },
  {
    path: '',
    loadChildren: () => import ('./views/master/master.module').then(m => m.MasterModule),
    data: {
      state: 'master',
      preload: true,
      delay: true
    },
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: '',
    canActivate: [AuthGuard]
  }
];

export class AppPreloadingStrategy implements PreloadingStrategy {
  routes: string[] = [];

  preload(route: Route, load: Function): Observable<any> {
    this.routes.push(route.path);

    const loadRoute = (delay: boolean) => delay
      ? timer(500).pipe(flatMap(_ => load()))
      : load();

    return (route.data && route.data.preload)
      ? loadRoute(route.data.delay)
      : of(null);
  }
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    CoreModule.forRoot(),
    RouterModule.forRoot(routes, { preloadingStrategy: AppPreloadingStrategy }),
    AppStoreModule
  ],
  providers: [
    AppPreloadingStrategy
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
